"use client";

import { usePathname } from "next/navigation";
import { useSyncExternalStore } from "react";
import WeddingFooterBar from "@/app/components/WeddingFooterBar";
import {
  isPhotoBoothKioskActive,
  PHOTO_BOOTH_KIOSK_CHANGE_EVENT,
} from "@/app/lib/weddingPortal";

function subscribeToKioskState(onStoreChange: () => void) {
  window.addEventListener("storage", onStoreChange);
  window.addEventListener(PHOTO_BOOTH_KIOSK_CHANGE_EVENT, onStoreChange);

  return () => {
    window.removeEventListener("storage", onStoreChange);
    window.removeEventListener(PHOTO_BOOTH_KIOSK_CHANGE_EVENT, onStoreChange);
  };
}

export default function AppFooterGate() {
  const pathname = usePathname();
  const kioskActive = useSyncExternalStore(
    subscribeToKioskState,
    isPhotoBoothKioskActive,
    () => true
  );

  if (kioskActive || pathname === "/booth") {
    return null;
  }

  return <WeddingFooterBar />;
}
